import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { CurrentCareerService } from '../services/current-career.service';
import { map } from 'rxjs/operators';

/**
 * Guard to check if the current career's logbook is open (not closed).
 * Prevents access to registration routes when logbook_closed is true or closing_date is not null.
 * Redirects to registrations-list if career is closed.
 */
export const careerOpenGuard = (): CanActivateFn => {
	return (ars: ActivatedRouteSnapshot, rss: RouterStateSnapshot) => {
		const currentCareerService = inject(CurrentCareerService);
		const router = inject(Router);

		return currentCareerService.currentCareer.pipe(
			map(career => {
				if (!career) {
					// No career loaded yet, redirect to dashboard
					router.navigate(['/dashboard']);
					return false;
				}

				if (currentCareerService.isCareerClosed(career)) {
					// Career logbook is closed or closing_date is not null, redirect to read-only registrations list
					router.navigate(['/registrations-list']);
					return false;
				}

				// Career logbook is open, allow access
				return true;
			})
		);
	};
};
